export default "__VITE_ASSET__d8cd074b__"